export enum OrganizationConnectionType {
  CloudBillingSync = 1,
}
